import authAxios from "../common/authAxios";

class CreateUsersService {

  async getRoles() {
    return await authAxios.get('/admin/get-roles');
  }

  async createUser(data) {
    return await authAxios.post('/admin/create-user', data);
  }

}

export default CreateUsersService